export default function creditStatusMapping(currentStatus, status) {
  const defaultReturn = 'default'
  // Check if it matches the status with current status
  if (typeof status[`${currentStatus}`] !== 'undefined') {
    return status[`${currentStatus}`]
  }
  return status[`${defaultReturn}`]
}
